import { Controller } from "@hotwired/stimulus"

// Bootstrap 3 モーダルのラッパ。connect で開き、disconnect で閉じる。
// Turbo Stream で要素ごと差し替えると hide のアニメーション途中で DOM が消えるため、
// backdrop / modal-open は disconnect 時に必ず掃除する。
//
// turbo:before-cache でも掃除する。Turbo のスナップショットは before-cache の
// 時点で採られ、Stimulus の disconnect は body 差し替え後に走る。モーダルを開いた
// まま画面遷移すると body.modal-open と .modal-backdrop がキャッシュに焼き付き、
// 戻ったときにスクロールがロックされたままになる。
export default class extends Controller {
  connect() {
    this.beforeCache = this.resetForCache.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCache)
    window.jQuery(this.element).modal("show")
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.hide()
  }

  close(event) {
    if (event) event.preventDefault()
    this.hide()
  }

  hide() {
    const $el = window.jQuery(this.element)
    if ($el.data("bs.modal")) {
      $el.modal("hide")
    }
    window.jQuery(".modal-backdrop").remove()
    window.jQuery("body").removeClass("modal-open").css("padding-right", "")
  }

  // hide() のフェードアウトは transition 完了後に display を戻すので、
  // スナップショットには開いたままの style が残る。キャッシュ用は同期で潰す。
  //
  // 見た目だけ閉じても、入力途中の中身と data-controller はスナップショットに
  // 残る。戻るで復元されると Stimulus が再接続し、connect() の modal("show") で
  // 古いフォームが開き直るため、スロットをページ初期状態と同じ空のシェルへ戻す。
  resetForCache() {
    this.hide()
    window.jQuery(this.element).removeClass("in").css("display", "")

    const frame = this.element.querySelector("turbo-frame")
    if (frame) frame.innerHTML = ""
    this.element.removeAttribute("data-controller")
  }
}
